import { Menu, MenuItem } from '@mui/material'
import { timeIntervalValues } from '../../../util/tradePage'
import { ExtraSmallButton, NonInteractiveTooltip } from '../../custom'
import { useSelector } from 'react-redux'
import { selectOptionChainTimeInterval } from '../../../selectors/home'
import { useCallback, useState, memo } from 'react'
import { useDispatch } from 'react-redux'
import AnalyticsManager from '../../../analytics/AnalyticsManager'
import { TimeBucket } from '../../../proto/generated/common'
import commonActions from '../../../actions/common.actions'
import { OptionChainViewKey } from '../../../assets/constants'

const OptionChainTimeIntervalMenu: React.FC<{ orderOptionChain?: boolean}> = ({ orderOptionChain = false }) => {
    const timeInterval = useSelector(selectOptionChainTimeInterval(OptionChainViewKey.LIVE, orderOptionChain ? 'extended' : 'normal'))
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>()
    const dispatch = useDispatch()

    const handleTimeIntervalChange = useCallback(
        (value: TimeBucket) => {
            if (value.timeSeries !== timeInterval.timeSeries || value.value !== timeInterval.value) {
                commonActions.setOptionChainTimeInterval(dispatch, {
                    timeBucket: value,
                    optionChainViewKey: OptionChainViewKey.LIVE,
                    type: orderOptionChain ? 'extended' : 'normal'
                })
            }
            AnalyticsManager.logEvent('Option Chain Time Interval Changed', { selected_value: value })
        },
        [dispatch, timeInterval]
    )

    return (
        <>
            <NonInteractiveTooltip title="Select time interval" arrow placement="top">
                <ExtraSmallButton
                    color="inherit"
                    id="basic-button"
                    variant="outlined"
                    data-event={'Time Interval Clicked'}
                    data-event-source={'option-chain-bar'}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    aria-haspopup="true"
                    sx={{
                        height: '32px',
                        width: '36px',
                        borderColor: (theme) => theme.palette.background.default,
                        textWrap: 'nowrap',
                        '&:not(first-child)': {
                            marginLeft: (theme) => theme.spacing(1)
                        }
                    }}
                >
                    {timeIntervalValues.find(t => t.value.value === timeInterval.value && t.value.timeSeries === timeInterval.timeSeries)?.label ?? ''}
                </ExtraSmallButton>
            </NonInteractiveTooltip>
            <Menu
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(undefined)}
                sx={{ '&.MuiInputBase-root': { height: '100%' } }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                {timeIntervalValues.map((t) => (
                    <MenuItem data-event={'Interval Changed'}
                        data-event-interval={t}
                        data-event-source={'option-chain-bar'} key={t.label} selected={timeInterval === t.value} onClick={() => handleTimeIntervalChange(t.value)}>
                        {t.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}

export default memo(OptionChainTimeIntervalMenu)
